import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { TagType } from '../../../../catalog/enums/TagType';
import './css/GameRoster1.css';
import { randomNumber } from '../../../../catalog/Others';
import { getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { context } from '../../../../globalState/GlobalState';
import { getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import { iceHockeyPlayerGameDetails } from '../../../../catalog/stats/iceHockey/IceHockeyPlayerStatsDescription';
import { SportsType } from '../../../../catalog/enums/SportsType';
import { rugbyPlayerGameDetails } from '../../../../catalog/stats/rugby/RugbyPlayerStatsDescription';
import { lacrossePlayerGameDetails } from '../../../../catalog/stats/lacrosse/LacrossePlayerStatsDescription';

const GameRoster1 = (props) => {
    const { game, tags, timeOfGame } = props;
    const { globalState } = useContext(context);

    const isUpcomingGame = () => {
        return getLocalTimeFromDatabaseTime(timeOfGame) > new Date();
    };

    const getPlayerDescription = (tagId) => {
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return iceHockeyPlayerGameDetails(tagId, game.goals, game.highlightsPerPlayer, game.penalties);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return rugbyPlayerGameDetails(tagId, game.tries, game.conversions, game.penaltyKicks, game.dropGoals, game.fouls);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return lacrossePlayerGameDetails(tagId, game.goals, game.highlightsPerPlayer, game.penalties);
        }
        return [];
    };

    return (
        <div className="game-roster1-container-container x-center m-t-30px">
            <div className="game-roster1-container x-center m-t-30px">
                <p className="game-roster1-title font-size-2xl text-left-align text-uppercase m-t-50px m-b-20px">Game Roster</p>
                <div className="game-roster1-roster box-shadow-black curve-border-10px">
                    {tags.sort((tagA, tagB) => {
                        return ((parseInt(tagA.label.split('-|-')[0], 10) > parseInt(tagB.label.split('-|-')[0], 10)) ? 1 : (parseInt(tagB.label.split('-|-')[0], 10) > parseInt(tagA.label.split('-|-')[0], 10)) ? -1 : 0);
                    }).map((tag) => {
                        return (
                            <React.Fragment key={tag.id}>
                                {!tag.deleted && tag.tagType === TagType.PLAYER ? (
                                    <>
                                        {getPlayerDescription(tag.id).length > 0 ? (
                                            <Accordion
                                                className="full-width"
                                                style={{ borderColor: globalState.websiteStyles.colors.primaryColor }}
                                                TransitionProps={{ unmountOnExit: true }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <div className="game-roster1-player-container-container full-width">
                                                        <div className="game-roster1-player-container full-width">
                                                            <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px m-l-15px m-r-0 game-roster1-team-number">{tag.label.split('-|-')[0]}</p>
                                                            <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px text-lightgray game-roster1-player-player">{tag.label.split('-|-')[1]}</p>
                                                            <p className="game-roster1-player font-size-2xl text-uppercase text-right-align m-t-10px m-b-10px m-l-20px m-r-0 game-roster1-position">{tag.label.split('-|-')[2]}</p>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>
                                                {isUpcomingGame() ? null : (
                                                    <AccordionDetails>
                                                        <div className="left-team-column half-width p-t-15px p-b-15px">
                                                            {getPlayerDescription(tag.id).map((detail) => {
                                                                return (
                                                                    detail ? <div key={randomNumber()} className="stat-detail normal-font-family text-uppercase text-left-align font-size-xs m-t-3px m-b-3px m-l-30px">{detail}</div> : null
                                                                );
                                                            })}
                                                        </div>
                                                    </AccordionDetails>
                                                )}
                                            </Accordion>
                                        ) : (
                                            <div className="game-roster1-player-container-container full-width">
                                                <div className="game-roster1-player-container full-width">
                                                    <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px m-l-30px m-r-20px game-roster1-team-number">{tag.label.split('-|-')[0]}</p>
                                                    <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px text-lightgray game-roster1-player-player">{tag.label.split('-|-')[1]}</p>
                                                    <p className="game-roster1-player font-size-2xl text-uppercase text-right-align m-t-10px m-b-10px m-l-20px m-r-50px game-roster1-position">{tag.label.split('-|-')[2]}</p>
                                                </div>
                                                <div className="game-roster1-player-bottom-bar full-width" style={getOptimXBackgroundStyle(globalState)}></div>
                                            </div>
                                        )}
                                    </>
                                ) : null}
                            </React.Fragment>
                        );
                    })}
                </div>
                <p className="game-roster1-title font-size-2xl text-left-align text-uppercase m-t-30px m-b-20px">Coaches</p>
                <div className="game-roster1-roster box-shadow-black curve-border-20px">
                    {tags.map((tag) => {
                        return (
                            <React.Fragment key={tag.id}>
                                {!tag.deleted && tag.tagType === TagType.COACH ? (
                                    <div className="game-roster1-player-container-container full-width">
                                        <div className="game-roster1-player-container full-width">
                                            <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px m-l-50px m-r-20px game-roster1-team-number">ST</p>
                                            <p className="game-roster1-player font-size-2xl text-uppercase text-left-align m-t-10px m-b-10px text-lightgray game-roster1-player-player">{tag.label.split('-|-')[0]}</p>
                                            <p className="game-roster1-player font-size-2xl text-uppercase text-right-align m-t-10px m-b-10px m-r-50px game-roster1-title">{tag.label.split('-|-')[1]}</p>
                                        </div>
                                        <div className="game-roster1-player-bottom-bar full-width" style={getOptimXBackgroundStyle(globalState)}></div>
                                    </div>
                                ) : null}
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

GameRoster1.propTypes = {
    game: PropTypes.object.isRequired,
    tags: PropTypes.array.isRequired,
    timeOfGame: PropTypes.object.isRequired,
};

export default memo(GameRoster1);
